import React from "react";
import Button from "@utdanningsdirektoratet/udir-gui/lib/elements/button/Button";
import { removePasCookies } from "../../utils/cookieUtils";
import ConfirmDialog from "@utdanningsdirektoratet/udir-gui/lib/components/dialog/ConfirmDialog";
import TextBlock from "@utdanningsdirektoratet/udir-gui/lib/components/content/TextBlock";
import Icon from "@utdanningsdirektoratet/udir-gui/lib/elements/icon/Icon";
class CookieCleaner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDialogOpen: false
        };
        this.removeCookies = this.removeCookies.bind(this);
        this.onRemoveClick = this.onRemoveClick.bind(this);
    }
    removeCookies() {
        removePasCookies();
        this.setState({
            confirmDialogOpen: false
        });
        this.props.onSuccess();
    }
    onRemoveClick() {
        if (this.props.showConfirmDialog) {
            this.setState({ confirmDialogOpen: true });
        }
        else {
            this.removeCookies();
        }
    }
    render() {
        const button = (React.createElement(Button, Object.assign({ onClick: this.onRemoveClick }, this.props.buttonStyle), this.props.label));
        if (!this.props.showConfirmDialog) {
            return button;
        }
        return (React.createElement("div", null,
            button,
            React.createElement(ConfirmDialog, Object.assign({}, this.props.dialogProps, { title: "Fjern informasjonskapsler", isOpen: this.state.confirmDialogOpen, onConfirm: this.removeCookies, onRequestClose: () => this.setState({ confirmDialogOpen: false }) }), this.props.dialogContent)));
    }
}
CookieCleaner.defaultProps = {
    label: "Fjern informasjonskapsler",
    dialogContent: (React.createElement("div", { className: "gui-row" },
        React.createElement("div", { className: "pw-20" },
            React.createElement(Icon, { icon: "trash", size: 90 })),
        React.createElement("div", { className: "pw-80" },
            React.createElement(TextBlock, null, "Dersom du velger Ok-knappen nedenfor, vil vi fjerne alle informasjonskapslene (cookies) som er registrert i din nettleser for denne tjenesten. Ingen informasjon vil g\u00E5 tapt, men du vil m\u00E5tte logge inn p\u00E5 nytt.")))),
    dialogProps: {
        confirmLabel: "Ok, fjern informasjonskapsler",
        style: "normal"
    }
};
export default CookieCleaner;
//# sourceMappingURL=CookieCleaner.js.map